import { render, staticRenderFns } from "./template.vue?vue&type=template&id=85b3c96c&scoped=true"
import script from "./template.vue?vue&type=script&lang=ts"
export * from "./template.vue?vue&type=script&lang=ts"
import style0 from "./template.vue?vue&type=style&index=0&id=85b3c96c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b3c96c",
  null
  
)

export default component.exports